export default () => {
  const open = useState('catalogFiltersModal', () => false)

  function openPanel() {
    open.value = true
  }

  function closePanel() {
    open.value = false
  }

  return {
    open,
    openPanel,
    closePanel,
  }
}
